import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {fetchAllSellersList, fetchAllContractorsList}  from 'shared/sharedMethods';
import {makeRequest, getErrorMessage, dispatchAction, displayMessage}  from 'actions';
import json2csv   from 'json2csv'
import {
    FETCH_TRANSACTIONS, UPDATE_TRANSACTION, RESET_TRANSACTIONS, DELETE_TRANSACTION,
    CLEAR_SELECTED_TRANSACTIONS, FETCH_ALL_SELLERS_LIST, ADD_TRANSACTION
} from "actions/actionTypes";
import ContractorReportsSearchBox from "./ContractorReportsSearchBox";
import ContractorReportsActionsBox from "./ContractorReportsActionsBox";
import ContractorReportsTable from "./ContractorReportsTable";
import moment   from 'moment'
import Select   from 'react-select'
import {Chart} from "react-google-charts";
import config from  '../../../../config';
import {Link} from 'react-router';
import { formatImageForBucket } from 'util/Utils';


import {Row, Col, Form, FormGroup, Checkbox, Modal, ControlLabel, FormControl, Button} from 'react-bootstrap';
var async = require('async');
import classNames from 'classnames';
import formatNumbers  from 'util/formatNumbers';
import {convertToHoursAndMinutes, base64ToHex, prepareSelectOptionsList,    customFormatter,
    getFieldByPathFormatter} from 'util/Utils';
var refundReasonCodesMap=[
    {tag:  'refund-broken'},
    {tag:   'refund-exchange'},
    {tag:  'refund-customercare'},
    {tag:   'refund-incorrect','text':'product was listed incorrectly' },
    {tag:    'refund-conditionwrong' ,'text':'was listed with an incorrect condition'},
    {tag:    'refund-missingpieces', 'text':'all items not included in the order'},
    {tag:   'refund-missingitem','text':'can’t find the item in the warehouse'},
    {tag:  'refund-unsafe','text':' wrong item sent'},
    {tag: 'refund-discountcode' ,'text':'customer forgot to use discount code'},
    {tag:  'refund-UPSsucks','text':'lost package'},
    {tag:   'refund-Fedexsucks','text':'lost package'},
    {tag:   'refund-vehosucks' ,'text':'damaged by Veho or lost package/never delivered'},
    {tag:  'refund-notshippable' ,'text': 'tems that are refunded because we can’t ship them (too large)'},
    {tag:   'refund-shippingdamage' ,'text':'was damaged in shipping (you will want to get pictures and alert warehouse manager to submit a claim to the carrier for the damage)'},
    ]

class ContractorsReportsPage extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);

    var stateData ={
        contractorData: 'initial',
        contractorSettings: {},
        lastWeekWorkingTime:moment.duration(0),
        selectedContractor:{}
    };
        if (    _.size(_.intersection(this.props.userReducer.user.Roles, ['Wingmom'])) > 0) {
            this.updateContractorTableData({value: _.get(this.props.userReducer, 'contractor._id')})
            stateData.selectedContractor= {
                value: _.get(this.props.userReducer, 'contractor._id'),
                UserID:_.get(this.props.userReducer, 'user._id'),
            }
        }
        this.state = stateData
        this.getContractorSettingsData()
        this.context.router.push('/admin/reports');
    };
    componentWillMount() {
        if ( _.size(_.intersection(this.props.userReducer.user.Roles, ['Wingmom'])) ==0 ) {
            fetchAllContractorsList.call(this)
            this.setState({
                contractorsOptionsList: prepareSelectOptionsList(_.filter(this.props.allContractorsList.data, {Status:'Active'}), {
                    label: 'UserFullName',
                    value: '_id',
                    customOptionFields:[
                        {fieldName:'UserID', path:'UserID._id'},
                    ]
                })
            })
        }
    }
    getContractorSettingsData() {
        this.props.makeRequest({Name: 'ContractorSettings'}, {
            "endpoint": "/settings",
            'not_display_error_message': true,
        }).then(function (res) {
            this.setState({'contractorSettings': _.get(res.data.data,[0,'Data'],{}) })
        }.bind(this)).catch(err => {

        });
    }
    getContractorPayBonusData(selectedContractor,ContractorLastWeekData) {
          this.props.makeRequest({
            sortBy:  'createdAt' + ':' + (-1),
            perPage:1,
            "ContractorID": _.get(selectedContractor, 'value'),
            "Types":[ "PayBonus"],}, {
            "endpoint": "/transactions",
            'not_display_error_message': true,
        }).then(function (res) {
              var foundPayBonus = _.find(res.data.data, function (payBonusRecord) {
                     if (_.get(payBonusRecord, 'CustomData.HistoricalDataRecordID').replace(/-/g, '') ==base64ToHex(ContractorLastWeekData._id).toLowerCase()){
                        return true
                    }
            })
            this.setState({'contractorPayBonus':_.get(foundPayBonus, '_id') ? foundPayBonus :{}})

        }.bind(this)).catch(err => {

        });
    }
    getContractorHistoricalDataRecords(params) {
        var queryParams =_.extend( {
             "Types":[ "ContractorPeriodData"],
            sortBy:  'createdAt' + ':' + (-1),
        },params)

        return this.props.makeRequest(queryParams, {
            'endpoint': '/historical_data',
        }).then(function (res) {

                return res.data.data
        })

    }
    componentWillReceiveProps(nextProps) {
        if (_.size(nextProps.allContractorsList.data) !== _.size(this.props.allContractorsList.data)) {
            this.setState({contractorsOptionsList: prepareSelectOptionsList( _.filter(nextProps.allContractorsList.data, {Status:'Active'})  , {
                label: 'UserFullName',
                value: '_id',
                customOptionFields:[
                    {fieldName:'UserID', path:'UserID._id'},
                 ]
            })})


        }

    }

     updateContractorTableData(selectedContractor = false) {
        if (!selectedContractor){
            selectedContractor = this.state.selectedContractor
        }
        var   self = this;
        this.setState({contractorData: []})
        if (!_.get(selectedContractor, 'value')) {
            return;
        }

         this.getContractorHistoricalDataRecords({ContractorID:_.get(selectedContractor, 'value')}).then(function (contractorHistoricalRecords) {
             var ContractorLastWeekData = _.get(contractorHistoricalRecords,0,{})
             var dataToUpdate = {
                 lastWeekProductsEdited:_.get(ContractorLastWeekData, 'CustomData.AverageProductsPostedToEdited.ProductsEdited',[]),
                 lastWeekProductsReturned:_.get(ContractorLastWeekData, 'CustomData.AverageProductsPostedToReturned.ProductsReturned',[]),
                 lastWeekWorkingTimeRecords:_.get(ContractorLastWeekData, 'CustomData.AverageProductTimeToPost.WorkingTimeRecords',[]),
                 lastWeekProductsFinalized:_.get(ContractorLastWeekData, 'CustomData.AverageProductTimeToFinalize.ProductsFinalized',[]),
                 lastWeekProductsFinalizedNumber: _.get(ContractorLastWeekData, 'CustomData.AverageProductTimeToFinalize.TotalProductsFinalized','n/a'),

                 lastWeekProductsPosted:_.get(ContractorLastWeekData, 'CustomData.AverageProductTimeToPost.ProductsPosted',[]),
                 lastWeekListingsNumber: _.get(ContractorLastWeekData, 'CustomData.AverageProductTimeToPost.TotalProductsPosted','n/a'),
                 lastWeekWorkingTime:moment.duration(_.get(ContractorLastWeekData, 'CustomData.AverageProductTimeToPost.TotalWorkingTimeDuration','n/a'),),
                 lastWeekEditedNumber: _.get(ContractorLastWeekData, 'CustomData.AverageProductsPostedToEdited.TotalProductsEdited','n/a'),
                 lastWeekReturnsNumber: _.get(ContractorLastWeekData, 'CustomData.AverageProductsPostedToReturned.TotalProductsReturned','n/a'),
                 oneWeekPeriodStartDate:ContractorLastWeekData._id ? moment(ContractorLastWeekData.DateFrom).format('MM/DD') : 'n/a',
                 oneWeekPeriodEndDate:ContractorLastWeekData._id ? moment(ContractorLastWeekData.DateTo).subtract(1, 'minute').format('MM/DD') : 'n/a',
                 ContractorLastWeekData:ContractorLastWeekData
             }
             var dateTo = moment(ContractorLastWeekData.DateTo).subtract(1, 'minute')
              if (_.get(ContractorLastWeekData, 'CustomData.AverageProductTimeToFinalize.TotalWorkingTimeDuration', 0) > 0 && dataToUpdate.lastWeekProductsFinalizedNumber!== 'n/a' && dataToUpdate.lastWeekProductsFinalizedNumber  >0) {
                 var duration = moment.duration(_.get(ContractorLastWeekData, 'CustomData.AverageProductTimeToFinalize.TotalWorkingTimeDuration', 0) / dataToUpdate.lastWeekProductsFinalizedNumber)
                  dataToUpdate.lastWeekProductsFinalizingTime =  convertToHoursAndMinutes(duration, {format: 'hours_and_minutes'})
             } else {
                 dataToUpdate.lastWeekProductsFinalizingTime  = 'n/a';
             }
                 self.setState(dataToUpdate)
           self.prepareContractorPeriodDataData(ContractorLastWeekData, {
                contractorHistoricalRecords:contractorHistoricalRecords,
            }).then((dataToUpdate)=>{

              self.setState(dataToUpdate)
          })


         })
    }
    prepareContractorPeriodDataData(ContractorLastWeekData, params){
        return new Promise((resolve, reject) => {
            var functionsToCall = [], self = this;
            functionsToCall.push(function (done) {
                var GoalReached = 'N/A', PercentToStretchGoal = 'N/A', BaseLineGoal = 'N/A', StretchGoal = 'N/A',
                    LastWeekContractorAverage = 'N/A',GoalReached = 'No'

                if (ContractorLastWeekData) {
                    var ContractorWorkingData = _.get(ContractorLastWeekData, 'CustomData.AverageProductTimeToPost')
                    if (ContractorWorkingData.Value < ContractorWorkingData.BaseLineGoal) {
                        GoalReached = 'Baseline Goal'
                    }
                    if (ContractorWorkingData.Value !== 'n/a') {
                        PercentToStretchGoal = formatNumbers.unformat(formatNumbers.toFixed(((ContractorWorkingData.Value / ContractorWorkingData.StretchGoal ) * 100) - 100, 1))

                        if (ContractorWorkingData.Value < ContractorWorkingData.BaseLineGoal) {
                            GoalReached = 'Baseline Goal'
                        }
                        if (ContractorWorkingData.Value < ContractorWorkingData.StretchGoal) {
                            //  PercentToStretchGoal = 0
                            GoalReached = 'Stretch Goal'
                        }
                        LastWeekContractorAverage = ContractorWorkingData.Value + ' min'
                    }
                    StretchGoal = ContractorWorkingData.StretchGoal + ' min'
                    BaseLineGoal = ContractorWorkingData.BaseLineGoal + ' min'

                } else {
                    LastWeekContractorAverage = 'Not found'
                }

                var totalWorkingTime = _.reduce(_.get(params, 'contractorHistoricalRecords', []), function (allPeriodsTotal, item) {
                    allPeriodsTotal += item.CustomData.AverageProductTimeToPost.TotalWorkingTimeDuration
                    return allPeriodsTotal
                }, 0)
                var totalProductsPosted = _.reduce(_.get(params, 'contractorHistoricalRecords', []), function (allPeriodsTotal, item) {
                    allPeriodsTotal += item.CustomData.AverageProductTimeToPost.TotalProductsPosted
                    return allPeriodsTotal
                }, 0)
                done(null, {
                    Title: 'Time To Post',
                    value: 'time_to_post',
                    _id: 1,
                    LastWeekContractorAverage: LastWeekContractorAverage,
                    ContractorAverage: totalProductsPosted == 0 ? 'N/A' : formatNumbers.toFixed(moment.duration(totalWorkingTime).asMinutes() / totalProductsPosted, 1) + ' min',
                    GoalReached: GoalReached,
                    BaseLineGoal: BaseLineGoal,
                    PercentToStretchGoal: PercentToStretchGoal,
                    StretchGoal: StretchGoal,

                })
            });
            functionsToCall.push(function (done) {
                var GoalReached = 'N/A', PercentToStretchGoal = 'N/A', BaseLineGoal = 'N/A', StretchGoal = 'N/A',
                    LastWeekContractorAverage = 'N/A'
                if (ContractorLastWeekData) {
                    var ContractorTimePeriodData = _.get(ContractorLastWeekData, 'CustomData.AverageProductTimeToFinalize', {})
                    var GoalReached = 'No', PercentToStretchGoal
                    if (ContractorTimePeriodData.Value < ContractorTimePeriodData.BaseLineGoal) {
                        GoalReached = 'Baseline Goal'
                    }
                    if (ContractorTimePeriodData.Value !== 'n/a') {
                        PercentToStretchGoal = formatNumbers.unformat(formatNumbers.toFixed(((ContractorTimePeriodData.Value / ContractorTimePeriodData.StretchGoal ) * 100) - 100, 1))

                        if (ContractorTimePeriodData.Value < ContractorTimePeriodData.BaseLineGoal) {
                            GoalReached = 'Baseline Goal'
                        }
                        if (ContractorTimePeriodData.Value < ContractorTimePeriodData.StretchGoal) {
                            //  PercentToStretchGoal = 0
                            GoalReached = 'Stretch Goal'
                        }
                        LastWeekContractorAverage = _.isUndefined(ContractorTimePeriodData.Value) ? 'N/A' : ContractorTimePeriodData.Value + ' min'
                    }

                    StretchGoal = _.isUndefined(ContractorTimePeriodData.StretchGoal) ? 'N/A' : ContractorTimePeriodData.StretchGoal + ' min'
                    BaseLineGoal = _.isUndefined(ContractorTimePeriodData.BaseLineGoal) ? 'N/A' : ContractorTimePeriodData.BaseLineGoal + ' min'

                } else {
                    LastWeekContractorAverage = 'Not found'
                }

                var totalWorkingTime = _.reduce(_.get(params, 'contractorHistoricalRecords', []), function (allPeriodsTotal, item) {
                    allPeriodsTotal += item.CustomData.AverageProductTimeToPost.TotalWorkingTimeDuration
                    return allPeriodsTotal
                }, 0)
                var totalProductsFinalized = _.reduce(_.get(params, 'contractorHistoricalRecords', []), function (allPeriodsTotal, item) {
                    allPeriodsTotal += _.get(item.CustomData, 'AverageProductTimeToFinalize.TotalProductsFinalized', 0)
                    return allPeriodsTotal
                }, 0)
                done(null, {
                    Title: 'Time To Finalize',
                    value: 'time_to_finalize',
                    _id: 4,
                    LastWeekContractorAverage: LastWeekContractorAverage,
                    ContractorAverage: totalProductsFinalized == 0 ? 'N/A' : formatNumbers.toFixed(moment.duration(totalWorkingTime).asMinutes() / totalProductsFinalized, 1) + ' min',
                    GoalReached: GoalReached,
                    BaseLineGoal: BaseLineGoal,
                    PercentToStretchGoal: PercentToStretchGoal,
                    StretchGoal: StretchGoal,

                })
            });
            /* get Posted to Returned */
            functionsToCall.push(function (done) {
                var GoalReached = 'N/A', PercentToStretchGoal = 'N/A', BaseLineGoal = 'N/A', StretchGoal = 'N/A',
                    LastWeekContractorAverage = 'N/A'
                if (ContractorLastWeekData) {
                    var ContractorWorkingData = _.get(ContractorLastWeekData, 'CustomData.AverageProductsPostedToReturned')
                     var GoalReached = 'No', PercentToStretchGoal
                    if (ContractorWorkingData.Value < ContractorWorkingData.BaseLineGoal) {
                        GoalReached = 'Baseline Goal'
                    }
                    if (ContractorWorkingData.Value !== 'n/a') {
                        PercentToStretchGoal = formatNumbers.unformat(formatNumbers.toFixed(((ContractorWorkingData.Value / ContractorWorkingData.StretchGoal ) * 100) - 100, 1))

                        if (ContractorWorkingData.Value < ContractorWorkingData.BaseLineGoal) {
                            GoalReached = 'Baseline Goal'
                        }
                        if (ContractorWorkingData.Value < ContractorWorkingData.StretchGoal) {
                            // PercentToStretchGoal = 0
                            GoalReached = 'Stretch Goal'
                        }
                        LastWeekContractorAverage = ContractorWorkingData.Value + '%'
                    }
                    StretchGoal = ContractorWorkingData.StretchGoal + '%'
                    BaseLineGoal = ContractorWorkingData.BaseLineGoal + '%'

                } else {
                    LastWeekContractorAverage = 'Not found'
                }

                var totalProductsReturned = _.reduce(_.get(params, 'contractorHistoricalRecords', []), function (allPeriodsAverage, item) {
                    allPeriodsAverage += item.CustomData.AverageProductsPostedToReturned.TotalProductsReturned
                    return allPeriodsAverage
                }, 0)
                var totalListingsNumber = _.reduce(_.get(params, 'contractorHistoricalRecords', []), function (allPeriodsTotal, item) {
                    allPeriodsTotal += item.CustomData.AverageProductTimeToPost.TotalProductsPosted
                    return allPeriodsTotal
                }, 0)
                done(null, {
                    Title: '% Returned',
                    value: 'percent_returned',
                    _id: 3,
                    LastWeekContractorAverage: LastWeekContractorAverage,
                    ContractorAverage: totalListingsNumber == 0 ? 'N/A' : formatNumbers.unformat(formatNumbers.toFixed((totalProductsReturned / totalListingsNumber ) * 100, 1)) + '%',

                    GoalReached: GoalReached,
                    PercentToStretchGoal: PercentToStretchGoal,
                    BaseLineGoal: BaseLineGoal,
                    StretchGoal: StretchGoal,

                })
            });

            async.parallel(functionsToCall,
                function (err, results) {
                      if (err) {
                        self.setState({contractorData: 'error'})
                        return;
                    }
                    var contractorCompensation = 'BaseCompensation'


                    var BaseLineGoalReached = _.every(results, item => {
                        return item.GoalReached == 'Baseline Goal' || item.GoalReached == 'Stretch Goal'
                    })
                    var StretchGoalReached = _.every(results, item => {
                        return item.GoalReached == 'Stretch Goal'
                    })
                    if (BaseLineGoalReached) {
                        contractorCompensation = 'BaseLineGoalCompensation'
                    }
                    if (StretchGoalReached) {
                        contractorCompensation = 'StretchGoalCompensation'
                    }
                    var dataToUpdate = {
                        contractorData: results,
                        contractorRelativeStrength: _.minBy(_.reject(results, {PercentToStretchGoal: 'N/A'}), function (item) {
                            return item.PercentToStretchGoal
                        }),
                        contractorRelativeWeakness: _.maxBy(_.reject(results, {PercentToStretchGoal: 'N/A'}), function (item) {
                            return item.PercentToStretchGoal
                        }),
                       // contractorCompensation: _.get(self.state.contractorSettings, contractorCompensation, '')
                    }
                    if (_.get(dataToUpdate, 'contractorRelativeStrength.value') == _.get(dataToUpdate, 'contractorRelativeWeakness.value')) {
                        _.set(dataToUpdate, 'contractorRelativeWeakness', {})
                        /* if contractorRelativeStrength and contractorRelativeWeakness are the same*/
                    }

                    resolve(dataToUpdate)
                });
        })
    }
    updateChartData(chartData) {
        console.log('chartData', chartData);
        var functionsToCall = [], self = this;
        if (!this.searchBox) {
            return;
        }
        var {errorMessage, queryParams} = this.searchBox.getSearchParams();
        if (errorMessage) {
            return this.props.displayMessage(errorMessage);
        }

        console.log('queryParams', queryParams);
     queryParams.interval = 'two_weeks'
      //  queryParams.interval = 'dailyKPI'
        functionsToCall.push(function (done) {
            var params = _.clone(queryParams)
            _.extend(params, _.get(self.state[chartData.value], 'filterOptions', {}));
            params.type = chartData.value
             self.setState({[chartData.value]: {...self.state[chartData.value], fetched: false}})
            return self.props.makeRequest(params, {
                'endpoint': '/reports',

                'type': 'post',
            }).then(function (res) {
                 self.setState({
                    [chartData.value]: {
                        ...self.state[chartData.value],
                        data: res.data.data,
                        fetched: true,
                        chartOptions: _.get(chartData, 'chartOptions', {})
                    }
                })
                done(null)
            }.bind(this)).catch(err => {
                self.setState({[chartData.value]: {data: [], fetched: true}})
                done(null)
            });
        });

        async.parallel(functionsToCall,
            function (err, results) {

            });


    }

    renderCharts() {
        var self = this;
        if (!this.searchBox) {
            return;
        }
        var chartsToDisplay = this.searchBox.state.chartsToDisplay;
        return <div style={{position: 'relative'}}>{_.map(chartsToDisplay, function (chart, index) {
            return <div key={chart.value}>
                <div className="bot20">{self.displayChartFilters(chart, index)}</div>
                <div className="top20">{self.displayChart(chart, index)}</div>

            </div>
        })}</div>
    }

    displayChartFilters(chartData, index) {
        return <Row>
      
            <Col md={4} xs={4} className="pull-right top10">
                <Button className="pull-right btn btn-primary"
                        disabled={this.state.pending}
                        onClick={ () => this.updateChartData(chartData)}>
                    Refresh
                </Button>
            </Col>

        </Row>
    }
    downloadReport(){
        var functionsToCall = [], self = this

        var toTime =  moment(_.get(this.state.contractorSettings,'ContractorDataLastSavedAt'))
        var fromTime =toTime.clone().subtract(8, 'days')
            this.getContractorHistoricalDataRecords({
               fromTime:fromTime.toISOString(),
               toTime:toTime.toISOString(),
              lookup:['ContractorID'],
                all:true,
      
    }).then(contractorsHistoricalRecords => {

             var reportFields=  [


                   {label: 'First Name', value:'ContractorPeriodData.UserID.firstName'},
                 {label: 'Last Name', value:'ContractorPeriodData.UserID.lastName'},
                   {label: 'From',  value: (row, field) => {
                       return  moment(row.DateFrom).format('MM-DD-YYYY')
                   }},
                 {label: 'To',  value: (row, field) => {
                     return  moment(row.DateTo).format('MM-DD-YYYY')
                 }},
                 {label: 'Working Time', value:  (row, field) =>{
                      return  convertToHoursAndMinutes( moment.duration(_.get(row, 'ContractorPeriodData.CustomData.AverageProductTimeToPost.TotalWorkingTimeDuration',0)) , {format: 'hrs:min'})
                 }},
                 {label: 'Total Product Posted', value:  (row, field) =>{
                     return  _.get(row, 'ContractorPeriodData.CustomData.AverageProductTimeToPost.TotalProductsPosted','n/a')
                 }},
                 {label: 'Total Product Finalized', value:  (row, field) =>{
                     return  _.get(row, 'ContractorPeriodData.CustomData.ContractorAverageProductsPostedToFinalized.TotalProductsFinalized','n/a')
                 }},
                 {label: 'Total Product Edited', value:  (row, field) =>{
                     return  _.get(row, 'ContractorPeriodData.CustomData.AverageProductsPostedToEdited.TotalProductsEdited','n/a')
                 }},
                 {label: 'Total Product Returned', value:  (row, field) =>{
                     return  _.get(row, 'ContractorPeriodData.CustomData.AverageProductsPostedToReturned.TotalProductsReturned','n/a')
                 }},
                   {label: 'Time To Post', value:  (row, field) =>{
                     return  _.get(_.find(_.get(row, 'contractorData',[]),{value:'time_to_post'}),'LastWeekContractorAverage', 'N/A')
                 }},
                 {label: 'Time To Post Goal Reached?', value:  (row, field) =>{
                     return  _.get(_.find(_.get(row, 'contractorData',[]),{value:'time_to_post'}),'GoalReached', 'N/A')
                 }},
                 {label: 'Time To Post Base Goal', value:  (row, field) =>{
                     return  _.get(_.find(_.get(row, 'contractorData',[]),{value:'time_to_post'}),'BaseGoal', 'N/A')
                 }},
                 {label: 'Time To Post Stretch Goal', value:  (row, field) =>{
                     return  _.get(_.find(_.get(row, 'contractorData',[]),{value:'time_to_post'}),'StretchGoal', 'N/A')
                 }},
                 {label: 'Time To Post Percent To Stretch Goal', value:  (row, field) =>{
                      return  _.get(_.find(_.get(row, 'contractorData',[]),{value:'time_to_post'}),'PercentToStretchGoal', 'N/A')
                 }},
                 {label: 'Time To Finalize', value:  (row, field) =>{
                      return  _.get(_.find(_.get(row, 'contractorData',[]),{value:'time_to_finalize'}),'LastWeekContractorAverage', 'N/A')
                 }},
                 {label: 'Time To Finalize Goal Reached?', value:  (row, field) =>{
                     return  _.get(_.find(_.get(row, 'contractorData',[]),{value:'time_to_finalize'}),'GoalReached', 'N/A')
                 }},
                 {label: 'Time To Finalize Base Goal', value:  (row, field) =>{
                     return  _.get(_.find(_.get(row, 'contractorData',[]),{value:'time_to_finalize'}),'BaseGoal', 'N/A')
                 }},
                 {label: 'Time To Finalize Stretch Goal', value:  (row, field) =>{
                     return  _.get(_.find(_.get(row, 'contractorData',[]),{value:'time_to_finalize'}),'StretchGoal', 'N/A')
                 }},
                 {label: 'Time To Finalize Percent To Stretch Goal', value:  (row, field) =>{
                      return  _.get(_.find(_.get(row, 'contractorData',[]),{value:'time_to_finalize'}),'PercentToStretchGoal', 'N/A')
                 }},
                 {label: '% Returned', value:  (row, field) =>{
                      return  _.get(_.find(_.get(row, 'contractorData',[]),{value:'percent_returned'}),'LastWeekContractorAverage', 'N/A')
                 }},
                 {label: '% Returned Goal Reached?', value:  (row, field) =>{
                     return  _.get(_.find(_.get(row, 'contractorData',[]),{value:'percent_returned'}),'GoalReached', 'N/A')
                 }},
                 {label: '% Returned Base Goal', value:  (row, field) =>{
                     return  _.get(_.find(_.get(row, 'contractorData',[]),{value:'percent_returned'}),'BaseGoal', 'N/A')
                 }},
                 {label: '% Returned Stretch Goal', value:  (row, field) =>{
                     return  _.get(_.find(_.get(row, 'contractorData',[]),{value:'percent_returned'}),'StretchGoal', 'N/A')
                 }},
                 {label: '% Returned Percent To Stretch Goal', value:  (row, field) =>{
                      return  _.get(_.find(_.get(row, 'contractorData',[]),{value:'percent_returned'}),'PercentToStretchGoal', 'N/A')
                 }}
               ]

               _.forEach(this.state.contractorsOptionsList, contractor=>{
                    // if (contractor.value !=='8G6R+gDrTeWzPMhfRjv6PA=='){
                   //     return true
                   // }
                   functionsToCall.push(function (done) {
                       var contractorPeriodDataRecord  =_.find(contractorsHistoricalRecords, item=>{
                           return item.ContractorID._id ==contractor.value
                       })
                       if (!contractorPeriodDataRecord){
                          return done(null, {})
                       }
                       self.prepareContractorPeriodDataData(contractorPeriodDataRecord, {
                         
                       }).then((dataToUpdate)=>{
                           dataToUpdate.ContractorPeriodData = contractorPeriodDataRecord
                           done(null,dataToUpdate )
                       })
                   })
               })
               async.parallel(functionsToCall,
                   function (err, dataForReport) {
                   console.log('dataForReport', dataForReport  );
                       var fields = _.map(reportFields, function (field) {
                           return _.extend({}, field, {default: ''});
                       })
                       var csvData = json2csv.parse(dataForReport, {
                           fields: fields,
                       })
                       var filename = "contractors_report_" + moment().format("YYYY-MM-DD-HH-mm") + ".csv";
                       var blob = new Blob([csvData], {type: 'text/csv;charset=utf-8;'});
                       if (navigator.msSaveBlob) { // IE 10+
                           navigator.msSaveBlob(blob, filename);
                       } else {
                           var link = document.createElement("a");
                           if (link.download !== undefined) { // feature detection
                               // Browsers that support HTML5 download attribute
                               var url = URL.createObjectURL(blob);
                               link.setAttribute("href", url);
                               link.setAttribute("download", filename);
                               link.style.visibility = 'hidden';
                               document.body.appendChild(link);
                               link.click();
                               document.body.removeChild(link);
                           }
                       }
                   })

        }).catch(err => {
            console.log('err', err );
        });
    }
    closeModal() {
        this.setState({
            showModal: false,

        });
    }
    displayChart(params, index) {
        if (_.isUndefined(_.get(this.state[params.value], 'fetched'))) {
            return null
        }

        if (_.get(this.state[params.value], 'fetched')) {
            if (_.size(this.state[params.value].data) > 1) {
                return <div>

                    <div className="chart-box">
                        <div className="chart-box__title">{params.title}</div>
                        <Chart
                            width="100%"
                            height="400px"
                            chartType="LineChart"
                            loader={<div className="pending-box"></div>}
                            data={this.state[params.value].data}
                            options={_.get(this.state[params.value], 'chartOptions', {tooltip: {isHtml: true}})}
                            // options={_.get(this.state[params.value], 'chartOptions', {tooltip: {isHtml: true }})}
                            rootProps={{'data-testid': index}}
                        /></div>
                </div>
            } else {
                return <div style={{
                    width: '100%',
                    height: 400,
                    fontSize: 20,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>No data found</div>
            }
        } else {
            return <div style={{width: '100%', height: 400, position: 'relative'}}>
                <div className="pending-box"></div>
            </div>
        }
    }
    getShopifyOrdersData(params) {
       return this.props.makeRequest({
            all:true,
           OrderIDs:params.OrderIDs,
        }, {
            'endpoint': '/shopify_orders',
            'not_display_success_message': true,
        }).then(function (res) {

           return  _.get(res.data, 'data',[])
       }).catch(err => {

           return Promise.reject(err)
       });
    }
    searchProducts(params) {
        return this.props.makeRequest(_.extend({
            lookup:['AllSaleTransactions'],
            all: true,
        },params), {
            "endpoint": "/products",
            'not_display_success_message': true
        }).then(function (res) {
          return  _.get(res.data, 'data',[])
        }).catch(err => {

            return Promise.reject(err)
        });
    }
    render() {

         var tipsForImprovement =_.get(_.find(_.get(this.state.contractorSettings, 'TipsForImprovement', []), {value:_.get(this.state, 'contractorRelativeWeakness.value')}),'items',[])
        return (
            <div className="admin-reports-page">
                <div  >
                    <Row className="">
                        <div   style={{}}
                               className={classNames('font-size-20 text-bold text-center ',{'welcome-user-box':  _.size(_.intersection(this.props.userReducer.user.Roles, ['Wingmom']))==0}, {'top25':  _.size(_.intersection(this.props.userReducer.user.Roles, ['Wingmom']))>0})}
                               >
                            Welcome {this.props.userReducer.user.firstName}
                        </div>
                        { _.size(_.intersection(this.props.userReducer.user.Roles, ['Wingmom'])) ==0 &&
                        <Col xs={6} sm={4} md={4} lg={3} className="top10">
                            <Select
                                tabIndex="0"
                                searchable={true}
                                selectedOptions
                                clearable={true}
                                placeholder="Contractors"
                                options={this.state.contractorsOptionsList}
                                // options={ this.props.foundContractorsList }
                                onChange={ (selectedOption) => {

                                    this.setState({
                                        selectedContractor: selectedOption ? selectedOption  : undefined,
                                    }, function () {
                                        this.updateContractorTableData()
                                   })
                                }}
                                value={_.get(this.state.selectedContractor, 'value')}
                            />
                        </Col>
                        }

                    </Row>
                    {this.state.contractorData !== 'initial' &&
                    <div style={{width: '100%', minHeight: 160, position: 'relative'}}>
                        {this.state.contractorData == 'error' ?
                            <div className="top20 ptop20 text-center font-size-20">Could not get data</div> :
                            <div >
                                {_.size(this.state.contractorData) > 0 ?
                                    <ContractorReportsTable
                                        oneWeekPeriodStartDate={_.get(this.state,'oneWeekPeriodStartDate', 'n/a')}
                                            oneWeekPeriodEndDate={_.get(this.state,'oneWeekPeriodEndDate', 'n/a')}
                                        contractorData={this.state.contractorData}
                                        {...this.props} >
                                    </ContractorReportsTable> :
                                   <div>
                                       {_.get(this.state.selectedContractor, 'value') ?
                                       <div className="pending-box"></div>:null}

                                       </div>
                                }
                            </div>
                        }
                    </div>
                    }
                    {_.get(this.state.selectedContractor, 'value') &&
                    <div className="top20 bot20 pbot20">
      
                        <div>
                            <div className=" bot20 top10 font-size-20 contractor-totals-box">

                                <div className=" blue text-bold right20">Last Week Totals</div>
                                <div className="text-center" ><div className="  pink">Listings</div>
                                    {_.size(_.get(this.state, 'lastWeekProductsPosted', [])) > 0 ?
                                        <Link className="left7  " target="_blank"
                                              to={'/admin/products?' + _.map(_.get(this.state, 'lastWeekProductsPosted', []), productID => {
                                                  return 'recordIDs=' + encodeURIComponent(productID)
                                              }).join('&')}>{this.state.lastWeekListingsNumber}</Link>
                                        : <span className="left7">{this.state.lastWeekListingsNumber}</span>
                                    }
                                </div>
                                <div className="text-center" ><div className="  pink">Time</div>
                                    {_.size(_.get(this.state, 'lastWeekWorkingTimeRecords', [])) > 0 ?
                                        <Link className="left7 " target="_blank"
                                              to={'/admin/time-tracking?' + _.map(_.get(this.state, 'lastWeekWorkingTimeRecords', []), productID => {
                                                  return 'recordIDs=' + encodeURIComponent(productID)
                                              }).join('&')}>{convertToHoursAndMinutes(this.state.lastWeekWorkingTime, {format: 'hrs:min'})}</Link>
                                        : <span
                                            className="left7">{convertToHoursAndMinutes(this.state.lastWeekWorkingTime, {format: 'hrs:min'})}</span>
                                    }
                                </div>
                                <div className="text-center" ><div className="  pink">Returns</div>
                                    {_.size(_.get(this.state, 'lastWeekProductsReturned', [])) > 0 ?
                                        <Link className="cursor-pointer" onClick={() => {
                                        this.searchProducts({
                                            recordIDs:_.get(this.state, 'lastWeekProductsReturned', [])
                                        }).then((data)=> {
                                            var transactionRecords = []
                                            _.forEach(data, product=>{
                                                var fromDate =moment(_.get(this.state,'ContractorLastWeekData.DateFrom') )
                                                var toDate = moment(_.get(this.state,'ContractorLastWeekData.DateTo') )
                                                console.log('fromDate, toDate', fromDate, toDate  );
                                                _.forEach(_.get(product, 'AllSaleTransactionRecords',[]), function (transactionRecord) {
                                                    if (_.includes(['Returned', 'Restocked'], _.get(transactionRecord, 'Status')) && _.get(transactionRecord, 'SaleData.OrderID')) {

                                                        var setToReturnedChangeLog = _.find(_.get(transactionRecord, 'ChangeLog', []), function (changeLog) {
                                                            if ( _.includes(['Returned', 'Restocked'],changeLog.To)) {
                                                                return true
                                                            }
                                                        })
                                                        console.log('setToReturnedChangeLog', setToReturnedChangeLog  );
                                                        if (setToReturnedChangeLog && fromDate.isBefore(moment(setToReturnedChangeLog.Date)) && toDate.isAfter(moment(setToReturnedChangeLog.Date))){

                                                            var OrderID = _.get(transactionRecord, 'SaleData.OrderID')
                                                            var cancelChangeLogForOrderFound = _.find(_.get(transactionRecord, 'ChangeLog', []), function (changeLog) {
                                                                if (changeLog.Webhook == 'order_cancellation' && changeLog.OrderID == OrderID) {
                                                                    return true
                                                                }
                                                            })
                                                            console.log('cancelChangeLogForOrderFound', cancelChangeLogForOrderFound  );
                                                            if (!cancelChangeLogForOrderFound) {

                                                                product.transactionReturned =transactionRecord
                                                                return false
                                                                
                                                            }
                                                        }
                                                    }
                                                })
                                                console.log('product.transactionReturned', product.transactionReturned  );
                                            })
                                 
      
                                                this.setState({
                                                    productRecords:data,
                                                    showModal: true
                                                })

                                        })
                                        }}
                                        >{this.state.lastWeekReturnsNumber}</Link>
      
                                        : <span className="left7">{this.state.lastWeekReturnsNumber}</span>
                                    }
                                </div>
                                <div className="text-center" ><div className="  pink">Edited Listings</div>
                                    {_.size(_.get(this.state, 'lastWeekProductsEdited', [])) > 0 ?
                                        <Link className="left7 " target="_blank"
                                              to={'/admin/products?' + _.map(_.get(this.state, 'lastWeekProductsEdited', []), productID => {
                                                  return 'recordIDs=' + encodeURIComponent(productID)
                                              }).join('&')}>{this.state.lastWeekEditedNumber}</Link>
                                        : <span className="left7">{this.state.lastWeekEditedNumber}</span>
                                    }
                                </div>
                                <div className="text-center" ><div className="  pink">Finalized Listings</div>
                                    {_.size(_.get(this.state, 'lastWeekProductsFinalized', [])) > 0 ?
                                        <Link className="left7 " target="_blank"
                                              to={'/admin/products?' + _.map(_.get(this.state, 'lastWeekProductsFinalized', []), productID => {
                                                  return 'recordIDs=' + encodeURIComponent(productID)
                                              }).join('&')}>{this.state.lastWeekProductsFinalizedNumber}</Link>
                                        : <span className="left7">{this.state.lastWeekProductsFinalizedNumber}</span>
                                    }
                                </div>
                                <div className="text-center" ><div className="  pink">Finalizing Time</div>
                                    <div>   { _.get(this.state, 'lastWeekProductsFinalizingTime','') }</div>
                                </div>
                            </div>

                        </div>


      
                        { !_.isUndefined(_.get(this.state, 'contractorRelativeStrength.Title')) &&
                        <div className="font-size-20 top10"><span className="blue text-bold">My Relative Strength: </span><span
                            className="font-size-18 text-bold">{_.get(this.state, 'contractorRelativeStrength.Title')  }</span>
                        </div>
                        }
                        { !_.isUndefined(_.get(this.state, 'contractorRelativeWeakness.Title')) &&
                        <div className="font-size-20 top10"><span className="blue text-bold">My Relative Weakness: </span><span
                            className="font-size-18 text-bold">{_.get(this.state, 'contractorRelativeWeakness.Title')  }</span>
                        </div>
                        }
                        {_.size(tipsForImprovement) > 0 &&
                        <div>
                            <div className="font-size-20 blue text-bold top10">Tips For Improvement:</div>
                            {_.map(tipsForImprovement,  (item,index)  => {
                                return <div key={index} className="left10">&#8226; {item}</div>
                            })}
                        </div>
                        }

                    </div>
                }
                    {config.checkAccessRights.call(this,{ resources:['contractors_reports_full']}) &&
                        <Row>
                    <Col md={3} xs={6} className="top10">
                        <button className="btn btn-primary" disabled={this.state.pending} onClick={ this.downloadReport.bind(this)}
                                type="button">
                            Download report
                        </button>

                    </Col>
                        </Row>
                    }
                    <ContractorReportsSearchBox
                        ref={(searchBox) => {
                            if (searchBox && !this.searchBox) {
                                this.searchBox = searchBox;

                            }
                        } }
                        updateState={() => {
                            this.setState({});
                        }}
                        updateChartData={
                            this.updateChartData.bind(this)
                        }
                        selectedContractor={
                            this.state.selectedContractor
                        }
                        {...this.props} >
                    </ContractorReportsSearchBox>
                    <Modal  onExited={this.closeModal.bind(this)} show={this.state.showModal}
                            onHide={(e) => this.setState({showModal: false})}>
                        <Modal.Header closeButton>
                            <div><div className="pull-left font-size-18">{'Items Returned'}</div><div className="purple pull-right font-size-18 right25"> {_.get(this.state,'oneWeekPeriodStartDate', 'n/a') + ' - '  +  _.get(this.state,'oneWeekPeriodEndDate', 'n/a')}</div></div>
                        </Modal.Header>
                        <Modal.Body>
                            <div style={{    overflow: 'auto', maxHeight:500}}>
                                { _.map(_.get(this.state, 'productRecords',[]), function (item, index) {
console.log(' item.transactionReturned',  item.transactionReturned  );
                                    var foundRefundTags = _.filter(_.get(item, 'transactionReturned.SaleData.ShopifyOrderTags', []), tag => {
                                        if (_.includes(tag.toLowerCase(), 'refund')) {
                                             return true
                                        }
                                    })
                                    console.log('foundRefundTags', foundRefundTags  );
                                     return (<div style={{borderBottom: '1px solid gray'}} className="pbot10 bot15"
                                                 key={index}>
                                        <div className="clearfix">

                                            <div style={{width: '25%'}} className="pull-left ">
                                                {_.get(item, 'OriginalImages.0.URL') &&
                                                <img style={{width: '!00%', height: 100}}
                                                     src={formatImageForBucket(_.get(item, 'OriginalImages.0.URL'))}/>
                                                }
                                            </div>
                                            <div style={{width: '75%'}} className="pull-right ">
                                                <div className="font-size-18 text-left ">
                                                    {_.get(item, 'ProductName')}
                                                </div>
                                                <div className="purple top5 font-size-18 text-left ">
                                                    {_.get(item, 'SKU')}
                                                </div>
                                                <div className="top5 font-size-18 text-left ">
                                                    {formatNumbers.formatMoney(_.get(item, 'Price'))}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="top5 font-size-18 text-left clearfix ">
                                            <div style={{width: '100px'}} className="text-bold pull-left ">
                                                {'Reason: '}</div>
                                            <div style={{width: '75%'}} className="pull-left ">
                                                { _.map(foundRefundTags, function (tag, index) {
                                                    var foundTag = _.find(refundReasonCodesMap, item =>{
                                                       return  _.includes(item.tag, tag.toLowerCase().replace(/[0-9.]/g, ""))
                                                    })
                                                    return <div className="top6  ">
                                                        <span className="text-bold ">{tag}</span>
                                                        <span className=" ">{_.get(foundTag, 'text') ? ' - ' +_.get(foundTag, 'text') : ''}</span>

                                                    </div>
                                                })}
                                            </div>
                                        </div>
                                    </div>)
                                })}
                            </div>

                        </Modal.Body>

                    </Modal>


                    {this.renderCharts()}

                </div>

            </div>
        );
    }
}


function mapStateToProps(state) {
    return {
        'adminTransactions': state.adminTransactions,
        userReducer: state.userReducer,
        allContractorsList: state.allContractorsList,
        allSellersList: state.allSellersList
    };

}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, displayMessage, dispatchAction}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ContractorsReportsPage);